import React from "react";
import { SkeletonLoader } from "@activecollab/components";

export const SplitDialogTableSkeleton = () => {
  return (
    <div
      className="tw-flex tw-flex-col tw-gap-4"
      data-testid="split-dialog-skeleton"
    >
      {[...Array(5)].map((_, index) => (
        <div
          key={index}
          className="tw-flex tw-justify-between tw-pl-3 tw-pr-10"
        >
          <SkeletonLoader className="tw-w-32" />
          <SkeletonLoader className="tw-w-10" />
        </div>
      ))}
    </div>
  );
};
